module.exports = __webpack_public_path__ + "Diploma_in_Game_Development_with_Unreal-e5885a29.webp";